/* TLR product grid — assets/tlr-product-grid.js
   AJAX size quick-add. Falls back to a normal form POST if fetch fails. */
(function () {
  const root = document.currentScript && document.currentScript.closest('.tlr-grid-sec');

  function toastEl(scope) {
    return scope.querySelector('[data-tlr-toast]');
  }

  function toast(scope, msg) {
    const el = toastEl(scope);
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.hidden = true; }, 2200);
  }

  function cartRoutes() {
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return { add: base + 'cart/add.js', get: base + 'cart.js' };
  }

  function bind(scope) {
    scope.querySelectorAll('[data-quick-add]').forEach(form => {
      form.addEventListener('click', async e => {
        const btn = e.target.closest('button[name="id"]');
        if (!btn || btn.disabled) return;
        e.preventDefault();

        btn.setAttribute('aria-busy', 'true');
        const routes = cartRoutes();

        try {
          const res = await fetch(routes.add, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.value), quantity: 1 }] })
          });
          if (!res.ok) throw new Error('add failed');

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          toast(scope, 'Added · ' + btn.textContent.trim());
        } catch (err) {
          form.submit(); /* graceful fallback: full page cart add */
        } finally {
          btn.removeAttribute('aria-busy');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.tlr-grid-sec').forEach(scope => {
      if (scope.dataset.tlrBound) return;
      scope.dataset.tlrBound = '1';
      bind(scope);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* theme editor re-renders sections */
  document.addEventListener('shopify:section:load', init);
})();
